import { getStorageBaseUrl } from "./azureStorageService";

/**
 * Check if a URL is a video URL (YouTube, Vimeo, etc.) that shouldn't be cached
 */
function isVideoUrl(url: string): boolean {
  const lowerUrl = url.toLowerCase();
  return (
    lowerUrl.includes("youtube.com") ||
    lowerUrl.includes("youtu.be") ||
    lowerUrl.includes("vimeo.com") ||
    lowerUrl.includes("dailymotion.com") ||
    lowerUrl.includes("twitch.tv") ||
    // Check if it's a blob path for video URLs (our backend pattern)
    lowerUrl.includes("video-urls/") ||
    // Also check for direct video files that might be external
    (lowerUrl.startsWith("http") &&
      (lowerUrl.includes(".mp4") ||
        lowerUrl.includes(".webm") ||
        lowerUrl.includes(".ogg") ||
        lowerUrl.includes(".mov") ||
        lowerUrl.includes(".avi")) &&
      !lowerUrl.includes("localhost") &&
      !lowerUrl.includes("devstoreaccount1"))
  );
}

// Helper function to determine asset type from URL
function getAssetTypeFromUrl(url: string): string {
  if (!url) return "unknown";

  const lowerUrl = url.toLowerCase();

  // Check file extension
  if (
    lowerUrl.endsWith(".jpg") ||
    lowerUrl.endsWith(".jpeg") ||
    lowerUrl.endsWith(".png") ||
    lowerUrl.endsWith(".gif") ||
    lowerUrl.endsWith(".webp") ||
    lowerUrl.endsWith(".svg")
  ) {
    return "image";
  } else if (
    lowerUrl.endsWith(".mp4") ||
    lowerUrl.endsWith(".webm") ||
    lowerUrl.endsWith(".ogg")
  ) {
    return "video";
  } else if (lowerUrl.includes("background")) {
    return "background";
  } else if (lowerUrl.includes("poster") || lowerUrl.includes("event")) {
    return "poster";
  }

  return "other";
}

// Azure Best Practice: Create a service for asset management
export const assetsService = {
  /**
   * Get asset URL - construct full URL without client-side caching
   * Service worker will handle caching for offline support
   */
  async getAsset(url: string, type?: string): Promise<string | null> {
    if (!url) return null;

    // If already a full URL (e.g., YouTube), return as-is
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }

    // Construct full Azure Storage URL
    const baseUrl = getStorageBaseUrl();
    return `${baseUrl}/digital-signage/${url}`;
  },
};
